import { ADVISER_CATCH_UP_POINTS_OF_CONTACT } from "../../../../constants/adviserCatchUp";

const normalise = (value) => String(value || "").trim().toLowerCase();

const normalisedPermissions = (permissions = []) =>
  new Set((Array.isArray(permissions) ? permissions : []).map(normalise));

export const isLoanRepaymentCharge = (charge = {}) =>
  [
    charge.chargeTypeId,
    charge.manualChargeTypeId,
    charge.chargeType,
    charge.manualChargeType,
  ].some(
    (value) => normalise(value).replace(/[\s_-]+/g, "") === "loanrepayment",
  );

const adviserSupportEmails = new Set(
  ADVISER_CATCH_UP_POINTS_OF_CONTACT.map((person) =>
    normalise(typeof person === "string" ? person : person?.email),
  ).filter(Boolean),
);

export const isAdviserSupportChargeUser = (email = "") =>
  adviserSupportEmails.has(normalise(email));

export const getAdviserChargeAccess = (permissions = [], userEmail = "") => {
  const available = normalisedPermissions(permissions);
  const canViewAllCharges =
    available.has("finance admin") || available.has("administrator");
  const isRestrictedViewer =
    isAdviserSupportChargeUser(userEmail) || available.has("tech");

  return {
    canAccessCharges: canViewAllCharges || isRestrictedViewer,
    canManageCharges: canViewAllCharges || isRestrictedViewer,
    canViewAllEntries: canViewAllCharges || isRestrictedViewer,
    canViewLoanRepayment: canViewAllCharges,
  };
};

export const canAccessManualCharge = (
  charge,
  { permissions = [], userEmail = "", adviserEmail = "" } = {},
) => {
  const access = getAdviserChargeAccess(permissions, userEmail);
  if (!access.canAccessCharges) return false;
  if (
    adviserEmail &&
    normalise(charge?.adviserEmail) !== normalise(adviserEmail)
  ) {
    return false;
  }
  if (!access.canViewLoanRepayment && isLoanRepaymentCharge(charge)) {
    return false;
  }
  return (
    access.canViewAllEntries ||
    normalise(charge?.createdBy?.email) === normalise(userEmail)
  );
};

export const filterManualChargesForAccess = (charges = [], access = {}) =>
  (Array.isArray(charges) ? charges : []).filter((charge) =>
    canAccessManualCharge(charge, access),
  );
